import { atom  } from "recoil";

export const bookingOptions = atom({
    key: "bokingOptionsState",
    default: {
        bookingOptimisationStatus: false ,
        scheduledDelivery : false ,
        rideStartTime : 0
    },
});

export const unoptmizedBooking = atom({
    key: "unoptmizedWaypointsState",
    default: {
        waypoints:[],
        priceDetails: {
            priceID: "",
            price: "",
            priceOriginal:"",
            priceType:9,
            tripType:"RS"
        },
        mapDetails: {
            distance: 0,
            mapRoute: ""
        },
        paymentDetails : {
            value: "",
            label: "",
            token:"" 
        }
    },
});

export const optmizedBooking = atom({
    key: "optmizedWaypointsState",
    default: {
        waypoints:[
            {
                postal: "",
                name: "",
                number : "",
                notes : "",
                floor : "",
                unit : "",
                latitude: 0,
                longitude: 0,
                address: ""
             }
        ],
        priceDetails: {
            priceID: "",
            price: "",
            priceOriginal:"",
            priceType:9,
            tripType:"RS"
        },
        mapDetails: {
            distance: 0,
            mapRoute: ""
        },
        paymentDetails : {
            value: "",
            label: "",
            token:"" 
        }
    },
});